module.exports = __webpack_public_path__ + "img/img172.5062893f.png";